import { paths } from '../../../helpers/WordPressPath';
import * as urlHelper from '../../../helpers/url.helper';

const solutionItems = (language) => [
  [
    'installation_type',
    {
      label: 'nav_solar_panels_homes',
      href: paths.solarPanelsHomes[language],
      subEntry: false,
    },
    {
      label: 'nav_solar_panels_companies',
      href: paths.solarPanelsCompanies[language],
      subEntry: false,
    },
    {
      label: 'nav_solar_panels_communities',
      href: paths.solarPanelsCommunities[language],
      subEntry: false,
    },
  ],
  [
    'products',
    {
      label: 'nav_solar_panels',
      href: paths.solarPanels[language],
      subEntry: false,
    },
    {
      label: 'nav_solar_battery_systems',
      href: paths.solarPanelsBattery[language],
      subEntry: false,
    },
    {
      label: 'nav_aerothermia',
      href: paths.heatPumps[language],
      subEntry: false,
    },
    {
      label: 'nav_electric_vehicles_chargers',
      href: paths.evChargers[language],
      subEntry: false,
    },
  ],
];

const discoverItems = (language) => [
  [
    '',
    {
      label: 'nav_solar_calculator',
      href: paths.solarCalculator[language],
      subEntry: false,
    },
    {
      label: 'nav_solar_payback',
      href: paths.solarPayback[language],
      subEntry: false,
    },
    {
      label: 'nav_subsidies',
      href: paths.subsidies[language],
      subEntry: false,
    },
    {
      label: 'nav_virtual_batteries',
      href: paths.virtualBatteries[language],
      subEntry: false,
    },
    {
      label: 'nav_ambassador_plus',
      href: paths.ambassadorPlus[language],
      subEntry: false,
    },
    {
      label: 'nav_reviews',
      href: urlHelper.getPathForOtherLanguage('/opiniones-clientes/', language),
      subEntry: false,
    },
  ],
];

const aboutUsItems = (language) => [
  [
    '',
    {
      label: 'nav_who_we_are',
      href: urlHelper.getPathForOtherLanguage('/sobre-nosotros/', language),
      subEntry: false,
    },
    {
      label: 'nav_ambassadors',
      href: `https://solar.sunhero.com/${language}/ambassadors/`,
      subEntry: false,
    },
    {
      label: 'nav_warranties',
      href: paths.warranties[language],
      subEntry: false,
    },
    {
      label: 'nav_careers',
      href: `https://solar.sunhero.com/${language}/careers/`,
      subEntry: false,
    },
    {
      label: 'nav_contact',
      href: urlHelper.getPathForOtherLanguage('/contacto/', language),
      subEntry: false,
    },
  ],
];

export const getMenuItems = (language) => [
  {
    label: 'nav_solutions',
    items: solutionItems(language),
  },
  {
    label: 'nav_discover',
    items: discoverItems(language),
  },
  {
    label: 'nav_about_us',
    items: aboutUsItems(language),
  },
  {
    label: 'nav_blog',
    href: paths.blog[language],
  },
  {
    label: 'nav_technical_support',
    href: paths.navTechnicalSupport[language],
  },
];
